import { booleanAttribute, Component, OnInit, output, inject, input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DateRangeComponent } from '../date-range/date-range.component';
import dayjs, { DateRange } from '../../utils/dayjs/dayjs';

export interface DateElement {
  value: number;
  label: string;
}
@Component({
  selector: 'app-range-form',
  imports: [ReactiveFormsModule, DateRangeComponent],
  templateUrl: './range-form.component.html',
  styleUrl: './range-form.component.css',
})
export class RangeFormComponent implements OnInit {
  public outputUpdate = output<DateRange>();
  public ranges = input<DateElement[]>();
  public min = input<string>();
  public max = input<string>();
  public all = input(false, { transform: booleanAttribute });
  public picker = input(false, { transform: booleanAttribute });
  protected form!: FormGroup;
  private previousRange = '30';
  private fb = inject(FormBuilder);

  public ngOnInit() {
    this.form = this.fb.group({
      period: '30',
    });
  }

  protected onFormChange() {
    const period = this.form.value.period;
    if (period === 'picker') return;
    this.previousRange = period;
    const end = dayjs();
    const start = dayjs().subtract(Number(period), 'day');
    this.outputUpdate.emit({ start, end });
  }

  protected onDateRangeChange(days: DateRange) {
    this.outputUpdate.emit(days);
  }

  protected onCancel() {
    this.form.controls['period'].setValue(this.previousRange);
  }
}
